import {
  ERPRJL,
  ERPSeedless,
  ERPUnity,
  ERPOdoo
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";
import { canViewByRoleCodes } from "src/core/shared/utils/canViewByRoleCodes";

import AdminDashboard from "./AdminDashboard/AdminDashboard";
import AdminListsPage from "./Lists/AdminListsPage";
import AccountManagerOrders from "./AccountManager/AccountManagerOrders";
import ConnectorIssueManagementPage from "./Orders/ConnectorIssueManagementPage";
import ViewQueueJobPage from "./Settings/ProcessJobQueue/ViewQueueJobPage";

export const AdminMain: IRoute[] = [
  {
    exact: true,
    path: "/admin/dashboard",
    pageComponent: AdminDashboard,
    title: null,
    icon: Icons.CALENDAR,
    menuTitle: "Dashboard",
    menuType: "ADMIN_MAIN",
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    title: "%CUSTOMERS% & %USERS%",
    icon: Icons.PEOPLE,
    menuType: "ADMIN_MAIN",
    privateRoute: true,
    path: "/admin/customers",
    roles: [ "admin" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/products",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    title: "%PRODUCTS%",
    icon: Icons.PRODUCT,
    menuType: "ADMIN_MAIN",
    permissions: [ "view-product" ],
    roles: [ "admin" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    privateRoute: true
  },
  {
    exact: true,
    title: "%ORDERS%",
    icon: Icons.CART,
    menuType: "ADMIN_MAIN",
    path: "/admin/orders",
    roles: [ "admin" ],
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    privateRoute: true
  },
  {
    exact: true,
    title: "%ORDERS%",
    icon: Icons.CART,
    menuType: "ADMIN_MAIN",
    path: "/admin/account-manager/orders",
    roles: [ "admin" ],
    pageComponent: AccountManagerOrders,
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "ALLOW"),
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    privateRoute: true
  },

  {
    exact: true,
    title: "%LISTS%",
    icon: Icons.TABLE,
    pageComponent: AdminListsPage,
    menuType: "ADMIN_MAIN",
    path: "/admin/lists",
    roles: [ "admin" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    privateRoute: true
  },
  {
    exact: true,
    path: "/admin/api-issue-management",
    pageComponent: ConnectorIssueManagementPage,
    title: "API %ISSUE% management",
    icon: Icons.ERRORCIRCLE,
    menuType: "ADMIN_MAIN",
    privateRoute: true,
    modules: [ "connector" ],
    permissions: [ "view-order" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/promotions",
    title: "Promotions",
    icon: Icons.PROMOTION,
    menuTitle: "Promotions",
    menuType: "ADMIN_MAIN",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "view-promotion" ],
    modules: [ "promotion" ]
  }

  // TODO: look more at this as a module
  // {
  //   exact: true,
  //   title: "Delivery Routes",
  //   icon: "lorry",
  //   menuType: "ADMIN_MAIN",
  //   privateRoute: true,
  //   pageComponent: DeliveryRoutesPage,
  //   path: "/admin/delivery-routes",
  //   roles: ["admin"],
  //   erp: [ERPSeedless]
  // }
];

const NestedAdminRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/api-issue-management/:processJobId",
    pageComponent: ViewQueueJobPage,
    title: "Queue Job",
    hidden: true,
    menuType: "EMPTY",
    privateRoute: true,
    parent: AdminMain[ 6 ],
    roles: [ "admin" ]
  }
];

export default [ ...AdminMain, ...NestedAdminRoutes ];
